/** Same-origin /api when served behind nginx; absolute URL for direct API access. */
export function resolveApiBaseUrl() {
  const configured = process.env.REACT_APP_API_URL;
  if (configured) {
    if (configured.startsWith('/')) {
      return `${window.location.origin}${configured}`.replace(/\/$/, '');
    }
    return configured.replace(/\/$/, '');
  }
  return `${window.location.origin}/api`;
}
